import React, { useState, useEffect, useCallback } from 'react';

function ServerStats() {
    const [serverCounts, setServerCounts] = useState({
        gb: 0,
        es: 0,
        br: 0
    });

    const servers = [
        {
            country: 'GB',
            flag: `${process.env.PUBLIC_URL}/img/gbl_2.png`,
            api: 'https://origins.habbo.com/api/public/origins/users',
            key: 'gb'
        },
        {
            country: 'ES',
            flag: `${process.env.PUBLIC_URL}/img/es_2.png`,
            api: 'https://origins.habbo.es/api/public/origins/users',
            key: 'es'
        },
        {
            country: 'BR',
            flag: `${process.env.PUBLIC_URL}/img/br_2.png`,
            api: 'https://origins.habbo.com.br/api/public/origins/users',
            key: 'br'
        }
    ];

    const fetchServerCounts = useCallback(async () => {
        const promises = servers.map(async (server) => {
            try {
                const response = await fetch(server.api);
                const data = await response.json();
                return { key: server.key, count: data.onlineUsers };
            } catch (error) {
                console.error(`Error fetching ${server.country} server count:`, error);
                return { key: server.key, count: 0 };
            }
        });

        const results = await Promise.all(promises);
        const newCounts = {};
        results.forEach(result => {
            newCounts[result.key] = result.count;
        });
        setServerCounts(newCounts);
    }, []);

    useEffect(() => {
        fetchServerCounts();
        const interval = setInterval(fetchServerCounts, 30000);
        return () => clearInterval(interval);
    }, [fetchServerCounts]);

    return (
        <div className="absolute top-0 right-0 h-[10px] bg-black bg-opacity-30 z-50 flex items-center gap-5 px-3 pt-2 pb-5 pl-4 pr-4 rounded-bl">
            {servers.map((server, index) => (
                <div key={index} className="flex items-center gap-1 pt-4 pb-3 mt-2">
                    <img
                        src={server.flag}
                        alt={server.country}
                        className="mr-1"
                        style={{
                            imageRendering: 'pixelated',
                            filter: 'drop-shadow(0px 1px 0 rgba(0,0,0,0.3))'
                        }}
                    />
                    <span
                        className="text-white font-['Jersey_10'] text-[17px] tracking-[1px] mt-0.45 uppercase"
                        style={{textShadow: '-1px -1px 0 rgba(0, 0, 0, 0.5), 1px -1px 0 rgba(0, 0, 0, 0.5), -1px 1px 0 rgba(0, 0, 0, 0.5), 1px 1px 0 rgba(0, 0, 0, 0.5), -1px 2px 0 rgba(0, 0, 0, 0.3)'}}
                    >
                        {serverCounts[server.key]}
                    </span>
                </div>
            ))}
        </div>
    );
}

export default ServerStats;